<template>
  <b-form-group :label-for="name" v-show="addresses && addresses.length > 1">
    <base-select
      selectClass="select-shadowed"
      v-model="addressSelected"
      :id="name"
      :name="name"
      :options="addresses"
      :reduce="addrr => addrr.ID"
      :clearable="false"
      @input="selected"
    />
  </b-form-group>
</template>

<script>
import { EventBus } from '@/helpers'
import BaseSelect from 'theme/components/Form/BaseSelect'

const populateAddresses = (vm, customerAddress = {}, index, isNewLine = false) => {
  let address = {
    ID: customerAddress.ID || index,
    region: {
      region_code: customerAddress.stateCode || '',
      region: customerAddress.stateCode || '',
      region_id: customerAddress.region_id || 0
    },
    country_id: customerAddress.countryCode && customerAddress.countryCode.value ? customerAddress.countryCode.value : '',
    street: [ customerAddress.address1 || '', customerAddress.address2 || '' ],
    telephone: customerAddress.phone || '',
    postcode: customerAddress.postalCode || '',
    city: customerAddress.city || '',
    firstname: customerAddress.firstName || '',
    lastname: customerAddress.lastName || '',
    company: customerAddress.company || '',
    vat_id: customerAddress.vat_id || '',
    label: `
      ${customerAddress.firstName || ''} ${customerAddress.lastName || ''},
      ${customerAddress.phone || ''}, ${customerAddress.address1 || ''} ${customerAddress.address2 || ''}, ${customerAddress.city || ''},
      ${customerAddress.stateCode || ''} ${customerAddress.postalCode || ''} ${customerAddress.country_id || ''}
    `
  }
  if (isNewLine) {
    address['ID'] = 0
    address['label'] = vm.$t('select-new-address')
  }
  return address
}

export default {
  name: 'SelectListAddress',
  props: {
    name: {
      type: String,
      default: 'select-list-address'
    }
  },
  data () {
    return {
      addressSelected: 0
    }
  },
  computed: {
    addresses () {
      let address = [{ ...populateAddresses(this, {}, 0, true) }]
      let addresses = this.$store.state.userAdmin.addresses
      if (addresses) {
        addresses.forEach((customerAddress, index) => {
          address.push({ ...populateAddresses(this, customerAddress, ++index) })
        })
      }
      return address
    }
  },
  methods: {
    selected ($event) {
      this.forceUpdate($event)
      return this.$emit('selected', this.findAddress($event))
    },
    forceUpdate (payload) {
      this.addressSelected = payload
      let currentAddress
      if (payload !== 0) {
        currentAddress = this.findAddress(payload)
      }
      EventBus.$emit('address-autocomplete::force-validate-reset', !currentAddress)
    },
    findAddress (id) {
      return this.addresses.find((addr) => addr.ID === id)
    }
  },
  mounted () {
    EventBus.$on('addressList::forceUpdate', this.selected)
  },
  destroyed () {
    EventBus.$off('addressList::forceUpdate', this.selected)
  },
  components: {
    BaseSelect
  }
}
</script>
